/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Periphery__factory } from "./Periphery__factory";
